import React, { useState, useEffect, useRef } from 'react';
import CodeMirror, { EditorDoc } from 'react-scale/corp/components/CodeMirror';
import useSnowflakeSqlCard from './useSnowflakeSqlCard';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { twMerge } from 'tailwind-merge';
import { compassErrorClassName } from 'react-scale/corp/views/DataCompassCardsV2/utils';
import { Link } from '@scale/scaleui-radix';

const SnowflakeCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const { code, setCode, hasError } = useSnowflakeSqlCard(index);
  const [localCode, setLocalCode] = useState<EditorDoc>(code ?? '');
  const isInternalUpdateRef = useRef(false);

  const SAMPLE_QUERY = `SELECT
    task AS "Task ID",
    attempted_by AS "Worker ID",
    response:"prompt"::string AS "Prompt"
FROM
    taskattempts
WHERE
    project = '663ace97ae4198b50160ecd7'
    AND response:"prompt"::string <> ''
LIMIT 10;`;

  const handleCodeChange = (value: EditorDoc) => {
    setLocalCode(value);
    const newCode = value.toString();
    isInternalUpdateRef.current = true;
    setCode(newCode);
  };

  const handleSampleQueryClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setLocalCode(SAMPLE_QUERY);
    isInternalUpdateRef.current = true;
    setCode(SAMPLE_QUERY);
  };

  useEffect(() => {
    if (isInternalUpdateRef.current) {
      isInternalUpdateRef.current = false;
      return;
    }
    setLocalCode(code ?? '');
  }, [code, index]);

  return (
    <div className="flex flex-col gap-4 relative">
      <CodeMirror
        language="sql"
        lineWrapping
        value={localCode}
        onUpdateValue={handleCodeChange}
        style={{ background: 'white' }}
        className={twMerge(hasError && !localCode && compassErrorClassName)}
      />

      {!code && (
        <div className="mt-2">
          Looking for somewhere to start?&nbsp;
          <Link className="cursor-pointer" onClick={handleSampleQueryClick}>
            Try a sample query extracting prompts from taskattempts.
          </Link>
        </div>
      )}
    </div>
  );
};

export default React.memo(SnowflakeCardComponent);
